import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import * as tracking from 'dibs-tracking';
import { Link } from 'dibs-elements/exports/Link';
import styles from './PdpSharedRestrictedMaterials.scss';
import getBuyerSupportLink from 'dibs-support-link/exports/getBuyerSupportLink';

import ExclamationIcon from 'dibs-icons/exports/legacy/ExclamationCircle';
import { FormattedMessage } from 'dibs-react-intl';

class PdpSharedRestrictedMaterialsComponent extends Component {
    constructor(props) {
        super(props);
        this.trackLinkClick = this.trackLinkClick.bind(this);
    }
    componentDidMount() {
        const { viewer } = this.props;

        if (viewer?.transactionWarnings?.hasRestrictedMaterials) {
            tracking.trackEvent({
                category: 'product',
                action: 'restricted material alert displayed',
                label: 'permit-needed',
            });
        }
    }
    trackLinkClick() {
        tracking.trackEvent({
            category: 'product',
            action: 'restricted material acknowledgement link clicked',
            label: 'permit-needed',
        });
    }
    render() {
        const { viewer, theme } = this.props;

        if (!viewer?.transactionWarnings?.hasRestrictedMaterials) {
            return null;
        }
        return (
            <div className={styles.wrapper}>
                <div className={styles.container}>
                    <ExclamationIcon
                        className={classNames(styles.exclamation, theme.exclamation)}
                    />
                </div>
                <div>
                    <FormattedMessage
                        id="PdpSharedRestrictedMaterials.allowCheckoutMessage"
                        defaultMessage="<strong>Item contains restricted materials.</strong> Expect 6 to 8 weeks for the seller to obtain any required permits, plus shipping and handling time."
                        values={{
                            strong: message => (
                                <span className={styles.messageHeader}>{message}</span>
                            ),
                        }}
                    />
                    <Link
                        href={getBuyerSupportLink('/en-us/articles/14517316102939/')}
                        className={styles.link}
                        target="_blank"
                        onClick={this.trackLinkClick}
                    >
                        <FormattedMessage
                            id="PdpSharedRestrictedMaterials.allowCheckoutMessage.learnMoreLink"
                            defaultMessage="Learn more"
                        />
                    </Link>
                </div>
            </div>
        );
    }
}

PdpSharedRestrictedMaterialsComponent.propTypes = {
    viewer: PropTypes.object.isRequired,
    theme: PropTypes.shape({
        exclamation: PropTypes.string,
    }),
};

PdpSharedRestrictedMaterialsComponent.defaultProps = {
    theme: {},
};

export const PdpSharedRestrictedMaterials = createFragmentContainer(
    PdpSharedRestrictedMaterialsComponent,
    {
        viewer: graphql`
            fragment PdpSharedRestrictedMaterials_viewer on Viewer {
                transactionWarnings(itemId: $itemId, country: $userCountryCode)
                    @include(if: $isClient) {
                    hasRestrictedMaterials
                }
            }
        `,
    }
);
